import React, { useState } from "react";
import { useJobDetails } from "@/context/JobDetailsContext";
interface DataItem {
	id: number;
	role: string;
	jd: string;
}

interface TableProps {

	setIsOpen: React.Dispatch<React.SetStateAction<any>>;
}

const JobDescriptionTable = ({

	setIsOpen,
}: TableProps) => {
	const { jobDetails, setJobDetails } = useJobDetails();
	const [selectedJd, setSelectedJd] = useState<DataItem | null>(null);
	const [expandedJdId, setExpandedJdId] = useState<number | null>(null);

	const data: DataItem[] = [
		{
			id: 1,
			role: "Senior Frontend Developer",
			jd: "Mandatory Skills \n 1. Knowledge of Functional and OO JavaScript/ES6 \n 2. Built web Applications using HTML5, CSS3, JavaScript with Frameworks like React.js(Hooks and context API), Vue.Js and svelte.js \n 3. Basic understanding of Typescript and type language concepts \n 4. Clear fundamental understanding of server side rendered apps, experience with frameworks like Next,js or Nuxt.js is Best \n 5. Good understanding of lib and frameworks like Webpack (4.0), lodash, any charting lib like d3.js or Victory \n 6. Expertise in using JavaScript state Management libraries such as Redux or Mobx \n 7. Prior experience in building responsive design layouts using a formal framework like Material UI. \n 8. Familiarity with best practices (web security concepts, ensuring browser & device compatibility, etc.)\n 9. Experience in development and debugging tools for cross-browser issues \n 10. Working knowledge of integrating with RESTful APIs for server-side functionality \n 11. Ability to work well individually and in a group setting, under pressure and deadlines \n Requirements \n B.Tech/ B.S. or M.Tech/ M.S. in Computer Science, IT or related field. 5-8 years of experience.",
		},
		{
			id: 2,
			role: "Senior Python Developer",
			jd: "Responsibilities: \n Design and develop automation solutions for healthcare processes using Python. \n Maintain and enhance existing solutions for seamless integration and improved performance. \n Conduct API testing and integration to ensure smooth connectivity with other systems. \n Apply problem-solving and critical thinking skills to quickly analyze and solve issues \n Collaborate with the team and communicate effectively to contribute to the transformation. Qualifications: \n Professional career of 3+ years as Python developer. \n Experience with API testing and integration \n Knowledge of automation frameworks such as Selenium or PlayWright (this is required)\n Familiarity with software development life cycle (SDLC)\n Good problem-solving and critical-thinking skills. Expectations:Follow the PEP 8 Style Guide. Modularize Code with Functions and Classes. Write Unit Test. Apply Design Patterns. Document Code and APIs. Optimize Performance. Understanding of relational databases and SQL. Familiarity with AWS, SQL, Docker, JavaScript. Experience with server-side applications",
		},
		{
			id: 3,
			role: "DevOps Engineer",
			jd: "Required Qualifications. Bachelor's degree in Computer Engineering, Computer Science, or related field; Alternatively, significant work experience as a Software Engineer. 1-5 years of experience working as a DevOps engineer. Experience in large-scale, secure, and high availability solutions in the AWS Cloud, using automation to support deployment, scaling, monitoring, and management (Terraform / CloudFormation / SDK, etc.). Experience building CI/CD pipelines (i.e., GitLab CI, GH Actions, Jenkins, Gitlab CI/CD). Familiarity with containerization technologies such as Docker and Kubernetes. Proficiency with one or more programming languages (Bash, Python, Go, etc). Proven ability to troubleshoot and identify the root cause of infrastructure and security Issues. Good communication and collaboration skills. Collaborate with the founding team in a fast-paced startup environment.",
		},
		{
			id: 4,
			role: "AS400 Programmer",
			jd: `Job Description: AS400 Programmer

Key Responsibilities:
• Develop and maintain programs in an IBM AS400 environment using RPG and CL programming
• Troubleshoot and resolve system issues, bugs, and other system defects related to the IBMi programs and interfaces
• Analyze and identify resolutions for production defects, consistently meeting the defined SLA
• Create queries and schedule datafixes for the database administrator to execute
• Develop temporary fix programs for bulk datafixes
• Implement code changes with necessary code review sign-offs, QA, and UAT approvals

Required Skills and Experience:
• 5+ years of experience in AS/400 application development
• 3+ years of application development experience in RPG, RPGLE, and CL
• 3+ years of IBMi SQL experience
• 2+ years of experience in .Net/C#
• Experience with Web Service development on AS/400 platform (preferred)

Technical Skills:
• IBM AS400/IBMi
• RPG/RPGLE
• CL Programming
• IBMi SQL
• .Net/C#
• Web Services`,
		},
		{
			id: 5,
			role: "Algorithm Developer",
			jd: `
• Develop and implement solutions to optimize and automate business decisions using large datasets and algorithms
• Apply state-of-the-art algorithms and heuristics to provide production-grade solutions for industry problems
• Create functional and engaging features by focusing on user needs and maintaining highest standards
• Utilize various metrics sources to deliver rapid iterations of software features
• Continuously improve software quality, consistency, maintainability, efficiency, and security
• Help define engineering best practices by staying updated with industry developments

Required Qualifications:
• B.Tech/B.S. or M.Tech/M.S. in Computer Science
• Two positions available:
  - Senior Role: 5-7 years of relevant experience
  - Mid-Level Role: 2-3 years of relevant experience

Technical Requirements:
• Strong computer science fundamentals in:
  - Object-oriented design
  - Data structures
  - Algorithm design
  - Problem solving
  - Complexity analysis
• Programming experience with modern languages (C# or C++)
• Good understanding of database theory and experience with relational DBMS

Soft Skills:
• Outstanding interpersonal and communication skills
• Strong attention to detail
• Ability to think abstractly
• Customer-focused mindset
• Quality-oriented approach`,
		},
	];

	const handleCheckboxChange = (data: DataItem) => {
		setSelectedJd((prevData) => (prevData?.id === data.id ? null : data));
	};

	const handleLoadClick = () => {
		if (selectedJd) {
			setJobDetails({ ...jobDetails, description: selectedJd.jd, title: selectedJd.role });
			setIsOpen(false);
		}
	};

	const toggleExpandedJd = (id: number) => {
		setExpandedJdId((prevId) => (prevId === id ? null : id));
	};

	return (
		<div>
			{/* <p className="flex justify-center items-center mb-2 font-semibold text-xl font-subheading">
				Load Example Job Description
			</p> */}
			<div className=" px-5">
				<div className="overflow-hidden border border-gray-200 rounded-xl ">
					<table className="min-w-full  text-left  rounded-xl  ">
						<thead className="bg-gray-100 ">
							<tr className="text-gray-500 font-semibold">
								<th className=" py-3 px-4   text-left ">Select</th>
								<th className=" py-3 px-4   text-left ">Role</th>
								<th className=" py-3 px-4   text-left ">Job Description</th>
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200 text-lg   font-normal">
							{data.map((item) => (
								<tr key={item.id} className="">
									<td className="px-4 py-2   text-gray-700">
										<input
											type="checkbox"
											className="bg-[#438437] border-gray-300 rounded transform scale-125"
											onChange={() => handleCheckboxChange(item)}
											checked={selectedJd?.id === item.id}
										/>
									</td>
									<td className="px-4 py-2  ">{item.role}</td>
									<td className="px-4 py-2  ">
										{expandedJdId === item.id ? (
											<>
												{item.jd} <br />
												<button
													className="text-[#438437] underline"
													onClick={() => toggleExpandedJd(item.id)}
												>
													See Less
												</button>
											</>
										) : (
											<>
												{item.jd.substring(0, 120)} ...{" "}
												<button
													className="text-[#438437] underline"
													onClick={() => toggleExpandedJd(item.id)}
												>
													See More
												</button>
											</>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			<div className="flex justify-center mt-4">
				<button
					className="ml-4 mt-4 px-7 py-2 font-medium text-[#438437] bg-[#BDE4C3] rounded-lg hover:scale-110 transition "
					onClick={handleLoadClick}
				>
					Load
				</button>
				<button
					className="ml-4 mt-4 px-7 py-2 font-medium border-[#BDE4C3] border-1  text-[#438437] rounded-lg hover:scale-110 transition "
					onClick={() => setIsOpen(false)}
				>
					Cancel
				</button>
			</div>
		</div>
	);
};

export default JobDescriptionTable;
